<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" id="epigraph" style="margin-top:20px;"><i>Wonders are many, and none is more wonderful than man; the power that crosses the white sea, driven by the stormy south-wind, making a path under surges that threaten to engulf him; and Earth, the eldest of the gods, the immortal, unwearied, doth he wear, turning the soil with the offspring of horses, as the ploughs go to and fro from year to year.</i></p>
<p class="ind"><i>And the light-hearted race of birds, and the tribes of savage beasts, and the sea-brood of the deep, he snares in the meshes of his woven toils, he leads captive, man excellent in wit. And he masters by his arts the beast whose lair is in the wilds, who roams the hills; he tames the horse of shaggy mane, he puts the yoke upon its neck, he tames the tireless mountain bull.</i></p>
<p class="ind"><i>And speech, and wind-swift thought, and all the moods that mould a state, hath he taught himself; and how to flee the arrows of the frost, when it is hard lodging under the clear sky, and the arrows of the rushing rain; yea, he hath resource for all; without resource he meets nothing that must come; only against Death shall he call for aid in vain; but from baffling maladies he hath devised escapes.</i></p>
<p class="right"><span class="small">SOPHOCLES</span>—Antigone</p>
<p class="ind" style="margin-top:20px;"><i>Now I blessed the condition of the dog and toad, yea, gladly would I have been in the condition of the dog or horse, for I knew they had no soul to perish under the everlasting weight of Hell or Sin, as mine was like to do. Nay, and though I saw this, felt this, and was broken to pieces with it, yet that which added to my sorrow was, that I could not find with all my soul that I did desire deliverance.</i></p>
<p class="right"><span class="small">JOHN BUNYAN</span>—Grace Abounding for the Chief of Sinners</p>
<p class="ind" style="margin-top:20px;">Wer immer strebend sich bemüht, den können wir erlösen.</p>
<p class="ind"><i>Whosoever unceasingly strives upward … him can we save.</i></p>
<p class="right"><span class="small">GOETHE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-epigraph.vue?36e4a04a